import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
const PowerMeterSVG =({id,x,y,index,isEVCb =false})=>{
    
   const {
    CBAssetList,
    CBEVList,
    UserScope,
    CBAssetListDispatch,
    assetDetailsReset,
    callSnackbar,
    selectedValuesHandler,
    pmConfigDataHandler,
    CBEVListDispatch,
    evpmConfigDataHandler,
  } = useContext(DesignAssetContext);
  const pMSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "pmAssetDetailsBlockGrid";
      const selectedAssetValue = "selectedAssetPM";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_PM_SELECT,
        payload: {
          index: index,
        },
      });
      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      pmConfigDataHandler(index);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
   const evPMSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "pmAssetDetailsBlockGrid";
      const selectedAssetValue = "selectedEvPM";
      CBEVListDispatch({
        type: ACTIONS.EV_PM_SELECT,
        payload: {
          index,
        },
      });
      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      evpmConfigDataHandler(index);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
    return (
    <g id={`PM${id}`}>
              <svg
                x={x}
                y={y}
                width="300px"
                height="140px"
                viewBox="0 0 100 160"
                onClick={isEVCb ? evPMSelectHandler : pMSelectHandler}
              >
                <title>{isEVCb ?CBEVList?.[index]?.powerMeterData?.name:CBAssetList?.[index]?.powerMeterData?.name}</title>
                <line
                  x1="30"
                  y1="127"
                  x2="80"
                  y2="127"
                  stroke={isEVCb?CBEVList?.[index]?.uiData.pmConfiguredGrid ? "var(--se-sld-circline)" : "#E47F00":CBAssetList?.[index]?.uiData.pmConfiguredGrid ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  id="Pm outer"
                  stroke="#42B4E6"
                  strokeWidth="3"
                  cx="100"
                  cy="127"
                  r="26"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="rgba(0, 135, 205, 0.2)"
                  style={isEVCb?CBEVList?.[index]?.uiData.pmSelected ? {} : { display: "none" }:CBAssetList?.[index]?.uiData.pmSelected ? {} : { display: "none" }}
                ></circle>
                <circle
                  id="pm inner"
                  stroke={isEVCb?CBEVList?.[index]?.uiData.pmConfiguredGrid ? "var(--se-sld-circline)" : "#E47F00":CBAssetList?.[index]?.uiData.pmConfiguredGrid ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeWidth="3"
                  cx="100"
                  cy="127"
                  r="18.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="var(--se-background-alternative)"
                ></circle>
                <text
                  id="PM"
                  fontSize="16"
                  fontWeight="normal"
                  stroke="var(--se-sld-circline)"
                  fontFamily="Nunito-Regular, Nunito"
                  fill="var(--se-sld-circline)"
                >
                  <tspan x="88" y="132">
                    PM
                  </tspan>
                </text>
              </svg>
            </g>
  )
}
export default PowerMeterSVG;